import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

import { FormItem } from '../../../../../../components/formReducer';
import Input from '../../../../components/input';
import Mobile from './mobile';
import GetMsgPin from './getMsgPin';
import MessagePin from './messagePin';
import Password from './password';
import PasswordRe from './passwordRe';
import VCode from './vCode';
import { registerPost, sendSms, cacheUserInfo } from '../../../../../../services/api';
import { cookie } from '@ifeng-fe/ui_base';
import { formatSearchParams } from '../../../../../../utils/utils';

class LoginById extends React.PureComponent {
    static propTypes = {};

    state = {
        fieldsValue: {},
        fieldsError: {},
        names: [],
        rules: [],
        error: '',

        captcha_id: '',

        imgCodeRequired: false,
        isAble: false,
        isChecked: true,
        searchParams: (window.location.search && formatSearchParams(window.location.search)) || {},
    };

    // 接收表单返回值
    handleChange = value => {
        const { fieldsValue } = this.state;

        fieldsValue[value.fieldsName] = value.fieldsValue;
        const newfieldsValue = JSON.parse(JSON.stringify(fieldsValue));

        this.setState({
            fieldsValue: newfieldsValue,
        });
    };

    // 接收错误信息
    handleError = error => {
        const { fieldsError } = this.state;

        fieldsError[error.fieldsName] = error.fieldsError;
        const newfieldsError = JSON.parse(JSON.stringify(fieldsError));

        this.setState({
            error,
            fieldsError: newfieldsError,
        });
    };

    // 清除指定错误信息
    clearErrors = name => {
        const { fieldsError, error } = this.state;
        const newFieldsError = JSON.parse(JSON.stringify(fieldsError));

        if (newFieldsError.hasOwnProperty(name)) {
            delete newFieldsError[name];
        }
        this.setState(
            {
                fieldsError: newFieldsError,
            },
            () => {
                if (error.fieldsName === name) {
                    this.setState({
                        error: '',
                    });
                }
            },
        );
    };

    // 收集校验规则
    selectRules = (name, itemRules) => {
        const { names, rules } = this.state;

        names.push(name);
        rules[name] = itemRules;
        this.setState({
            names,
            rules,
        });
    };

    // 执行全局校验
    runCheck = () => {
        const { rules, fieldsValue } = this.state;

        for (const name in rules) {
            if (rules.hasOwnProperty(name)) {
                const itemRules = rules[name];

                this.handleCheck(fieldsValue[name], itemRules, name);
            }
        }
    };

    // 全局错误中转
    errCallBack = (name, error) => {
        const { fieldsError, names } = this.state;

        fieldsError[name] = error;
        const newfieldsError = JSON.parse(JSON.stringify(fieldsError));

        this.setState(
            {
                fieldsError: newfieldsError,
            },
            () => {
                for (let i = 0; i < names.length; i++) {
                    const item = names[i];

                    if (newfieldsError[item]) {
                        this.setState({
                            error: {
                                fieldsName: item,
                                fieldsError: newfieldsError[item],
                            },
                        });
                        break;
                    }
                }
            },
        );
    };

    // 处理全局校验
    handleCheck = (value, rules, name) => {
        for (let i = 0; i < rules.length; i++) {
            const item = rules[i];

            // 必填项
            if (item.hasOwnProperty('required') && item.required === true) {
                if (!value) {
                    this.errCallBack(name, item.message);
                    console.warn(`fieldsError:[${name}] ===== ${item.message}`);
                    break;
                } else {
                    this.clearErrors(name);
                }
            }

            // 正则校验
            if (item.hasOwnProperty('pattern')) {
                const pattern = item.pattern;

                if (!pattern.test(value)) {
                    this.errCallBack(name, item.message);
                    console.warn(`fieldsError:[${name}] ===== ${item.message}`);
                    break;
                } else {
                    this.clearErrors(name);
                }
            }

            // 自定义检验函数
            if (item.hasOwnProperty('validator')) {
                let flag = false;
                const validator = item.validator;
                const callBack = message => {
                    if (message) {
                        this.errCallBack(name, message);
                        console.warn(`fieldsError:[${name}] ===== ${message}`);
                        flag = true;
                    } else {
                        flag = false;
                        this.clearErrors(name);
                    }
                };

                validator(value, callBack);
                if (flag) {
                    break;
                }
            }
        }
    };

    // 确认密码
    handleCheckPW = (value, cb) => {
        const {
            fieldsValue: { password },
        } = this.state;

        if (value !== password) {
            cb('前后密码不一致');
        }
    };

    handleChangeCheckbox = () => {
        this.setState({
            isChecked: !this.state.isChecked,
        });
    };

    refreshVCode = null;

    // 绑定获取验图片证码
    bindGetCode = cb => {
        this.refreshVCode = cb;
    };

    // 获取图片验证码id
    getImgCodeId = codeId => {
        this.setState({
            captcha_id: codeId,
        });
    };

    getMsgPin = async callback => {
        const { fieldsValue, fieldsError } = this.state;

        if (!fieldsValue['mobile']) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: '请填写手机号!',
            });
        } else if (fieldsError['mobile']) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: fieldsError['mobile'],
            });
        } else {
            // eslint-disable-next-line no-lonely-if
            if (!this.state.imgCodeRequired) {
                const res = await sendSms(
                    {
                        mobile: fieldsValue['mobile'],
                        smsform: 1,
                    },
                    this.showImgCode,
                );

                if (this.state.imgCodeRequired) {
                    return;
                } else if (!res) {
                    return;
                }

                callback();
            } else if (this.state.imgCodeRequired) {
                const res = await sendSms(
                    {
                        mobile: fieldsValue['mobile'],
                        smsform: 1,
                        captcha_code: fieldsValue['captcha_code'],
                        captcha_id: this.state.captcha_id,
                    },
                    this.showImgCode,
                    this.getFailCallbak,
                );

                if (res.smscode_len === 6) {
                    this.setState({
                        imgCodeRequired: false,
                    });
                    callback();
                }
            }
        }
    };

    showImgCode = () => {
        this.handleError({
            fieldsName: 'captcha_code',
            fieldsError: '需要图片二维码',
        });
        this.setState({
            imgCodeRequired: true,
        });
    };

    getFailCallbak = (msg, tip) => {
        // console.log(msg);
        if (msg && msg === 'CaptchaNotMatch') {
            this.handleError({
                fieldsName: 'captcha_code',
                fieldsError: tip,
            });
        } else if (
            [
                'SendSMSTooManyPerMinute',
                'SendSMSTooManyPerHour',
                'SendSMSTooManyPerDay',
                'SendSMSTooManyPerYear',
                'SendSMSTooManyPerMonth',
                'IPNotInMainland',
            ].includes(msg)
        ) {
            this.handleError('captcha_code', {
                fieldsName: 'smscode',
                fieldsError: tip,
            });
        } else {
            alert(tip);
        }
        this.refreshVCode();
    };

    // 提交登录
    handleSubmmit = () => {
        if (this.state.isChecked === false) {
            return;
        }

        this.runCheck();

        const { fieldsValue, fieldsError } = this.state;

        console.log(fieldsValue, fieldsError);

        if (!fieldsError || !Object.keys(fieldsError).length) {
            const { mobile, password, smscode } = fieldsValue;

            const params = {
                mobile,
                password,
                smscode,
            };

            console.log(params);

            this.asyncLoginPost(params, this.registerFailCallback);
        }
    };

    registerFailCallback = (msg, tip) => {
        if (msg && (msg === 'IllegalMobile' || msg === 'MobileAlreadyExists')) {
            this.handleError({
                fieldsName: 'mobile',
                fieldsError: tip,
            });
        } else if (msg && (msg === 'IllegalSMSCode' || msg === 'SMSCodeNotFound' || msg === 'SMSCodeNotMatch')) {
            this.handleError({
                fieldsName: 'smscode',
                fieldsError: tip,
            });
        } else if (msg && msg === 'AccountNotRegistered') {
            this.handleError({
                fieldsName: 'account',
                fieldsError: '用户名未找到！',
            });
        } else {
            alert(tip);
        }
        this.refreshVCode();
    };

    // 登录请求
    asyncLoginPost = async (params, failCallbak) => {
        const res = await registerPost(params, failCallbak);

        if (res) {
            this.setState({
                error: {},
            });

            clearInterval(this.LOGINTIMER);
            this.LOGINTIMER = setInterval(() => {
                const sid = cookie.get('sid');

                if (sid) {
                    console.log(sid);

                    clearInterval(this.LOGINTIMER);
                    cacheUserInfo().then(res => {
                        const cb = this.searchParams.cb;

                        if (cb) {
                            location.href = encodeURIComponent(cb);
                        } else {
                            location.href = '/registersuccess';
                        }
                    });
                }
            }, 100);
        }
    };

    render() {
        const { error, fieldsError, imgCodeRequired, isAble, isChecked } = this.state;

        const config = {
            onChange: this.handleChange,
            onBlur: this.handleChange,
            onError: this.handleError,
            clearErrors: this.clearErrors,
            callbackRules: this.selectRules,
            fieldsError,
        };

        return (
            <div className={styles.loginById}>
                <div className={styles.innerWrapper}>
                    {imgCodeRequired ? (
                        <FormItem
                            {...config}
                            name={'captcha_code'}
                            validateTrigger={'blur'}
                            rules={[
                                {
                                    required: true,
                                    message: '请输入验证码!',
                                },
                                {
                                    pattern: /^[0-9a-zA-Z]{6}$/,
                                    message: '验证码格式不正确',
                                },
                            ]}>
                            <VCode bindGetCode={this.bindGetCode} getImgCodeId={this.getImgCodeId} />
                        </FormItem>
                    ) : null}

                    <FormItem
                        {...config}
                        name={'mobile'}
                        validateTrigger={'blur'}
                        rules={[
                            {
                                required: true,
                                message: '请输入手机号!',
                            },
                        ]}>
                        <Mobile />
                    </FormItem>

                    <GetMsgPin isAble={isAble} getCode={this.getMsgPin} />

                    <FormItem
                        {...config}
                        name={'smscode'}
                        validateTrigger={'blur'}
                        rules={[
                            {
                                required: true,
                                message: '请输入验证码!',
                            },
                            {
                                pattern: /^[0-9]{6}$/,
                                message: '验证码格式不正确!',
                            },
                        ]}>
                        <MessagePin />
                    </FormItem>

                    <FormItem
                        {...config}
                        name={'password'}
                        validateTrigger={'change'}
                        rules={[
                            {
                                required: true,
                                message: '请输入密码!',
                            },
                            {
                                pattern: /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
                                message: '密码格式不正确！',
                            },
                        ]}>
                        <Password />
                    </FormItem>

                    <FormItem
                        {...config}
                        name={'PasswordRe'}
                        validateTrigger={'blur'}
                        rules={[
                            {
                                required: true,
                                message: '请确认密码!',
                            },
                            {
                                validator: this.handleCheckPW,
                            },
                        ]}>
                        <PasswordRe />
                    </FormItem>
                </div>
                <div className={styles.agree}>
                    <label className={styles.checkBox}>
                        <input type="checkbox" checked={!!isChecked} onChange={this.handleChangeCheckbox} />
                        <span className={styles.txt}>
                            我已阅读并同意<a href="https://id.ifeng.com/user/agreement" target="_blank">
                                《网络服务协议》
                            </a>
                            <a href="https://id.ifeng.com/user/protected" target="_blank">
                                《个人信息保护政策》
                            </a>
                        </span>
                    </label>
                </div>
                <div className={`${styles.submmitBtn} ${isChecked ? '' : styles.disable}`} onClick={this.handleSubmmit}>
                    提交注册
                </div>
            </div>
        );
    }
}

export default errorBoundary(LoginById);
